import {
  getDocOperationServiceEndPoint,
  endPoints,
} from "@/Services/base-url/api-constants";
import { getAuthHeader } from "@/utils/helper";

const createDocOperation = (
  payload: any,
  authIntent?: "signin" | "signup"
) => {
  return fetch(
    getDocOperationServiceEndPoint(
      endPoints.docOperationService.DOC_OPERATION
    ),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
        "auth-intent": authIntent || "signin",
      },
      body: JSON.stringify(payload),
    }
  );
};

export default {
  createDocOperation,
};